import { Modal } from '@roo/roo';
import React, { useState, useRef } from 'react';
import { writeOnce, has } from '@utils/persist';
import GuidImg from '@assets/images/guide.png';

import './index.less';

export const REVIEW_GUIDE_KEY = 'REVIEW_GUIDE';

const Guide = () => {
  const [visible, setVisible] = useState(!has(REVIEW_GUIDE_KEY));
  const guideRef = useRef(null);
  const onConfirm = () => {
    writeOnce(REVIEW_GUIDE_KEY);
    setVisible(false);
  };

  return (
    visible && (
      <div ref={guideRef} className="guide">
        <img className="guide__image" src={GuidImg} />
        <Modal
          title="评审信息"
          visible
          backdrop={false}
          closable={false}
          showCancelButton={false}
          confirmText="我知道了"
          className="guide__confirm"
          popupContainer={guideRef.current}
          onConfirm={() => onConfirm()}
        >
          点击【评审信息】切换页面进入评审详情页。
        </Modal>
      </div>
    )
  );
};

export default Guide;
